import { LocaleLink as Link } from "@/i18n/LocaleLink";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import sealProgrammaUrl from "@/assets/seal-programa.png";

const Footer = () => {
  const { t } = useTranslation("nav");
  return (
    <footer className="relative mt-24 overflow-hidden bg-ink text-ink-foreground">
      <div className="absolute inset-0 bg-mesh opacity-20" />
      <div className="container relative pt-20 pb-10">
        <Link to="/" className="block">
          <h2 className="font-display text-[18vw] font-bold leading-[0.85] tracking-tighter md:text-[14vw]">
            self<span className="font-serif-italic font-normal text-accent">educate</span>.
          </h2>
        </Link>

        <div className="mt-16 grid gap-10 border-t border-background/15 pt-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <p className="max-w-md text-base text-ink-foreground/70 text-pretty">{t("footer.tagline")}</p>
            <a
              href="mailto:selfeducate.ro@gmail.com"
              className="mt-6 inline-flex items-center gap-2 font-display text-2xl font-medium underline-offset-4 hover:underline"
            >
              selfeducate.ro@gmail.com <ArrowUpRight className="h-5 w-5" />
            </a>
          </div>

          <div>
            <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-ink-foreground/50">{t("footer.learn")}</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/subjects" className="text-ink-foreground/80 hover:text-accent">{t("footer.allSubjects")}</Link></li>
              <li><Link to="/subjects/romanian" className="text-ink-foreground/80 hover:text-accent">{t("footer.romanian")}</Link></li>
              <li><Link to="/materiale" className="text-ink-foreground/80 hover:text-accent">{t("footer.libraryFull")}</Link></li>
              <li><Link to="/tutorials" className="text-ink-foreground/80 hover:text-accent">{t("footer.tutorials")}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-ink-foreground/50">{t("footer.company")}</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/misiune" className="text-ink-foreground/80 hover:text-accent">{t("footer.missionLink")}</Link></li>
              <li><Link to="/pricing" className="text-ink-foreground/80 hover:text-accent">{t("footer.betaLink")}</Link></li>
              <li><Link to="/faq" className="text-ink-foreground/80 hover:text-accent">{t("footer.faqLink")}</Link></li>
              <li><Link to="/contact" className="text-ink-foreground/80 hover:text-accent">{t("footer.contactLink")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start gap-6 border-t border-background/15 pt-8 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <img
              src={sealProgrammaUrl}
              alt={t("footer.sealAlt")}
              width={96}
              height={96}
              loading="lazy"
              className="h-20 w-20 shrink-0 brightness-0 invert opacity-90 md:h-24 md:w-24"
            />
            <p className="max-w-xs text-xs leading-relaxed text-ink-foreground/70">
              <span className="block font-display text-sm font-semibold text-ink-foreground">{t("footer.sealTitle")}</span>
              {t("footer.sealBody")}
            </p>
          </div>

          <div className="flex flex-col gap-3 text-xs font-mono uppercase tracking-widest text-ink-foreground/50 md:items-end">
            <span>© {new Date().getFullYear()} Self Educate</span>
            <nav className="flex flex-wrap gap-x-5 gap-y-2 normal-case tracking-normal">
              <Link to="/legal/termeni" className="hover:text-accent">{t("footer.terms")}</Link>
              <Link to="/legal/confidentialitate" className="hover:text-accent">{t("footer.privacy")}</Link>
              <Link to="/legal/returnare" className="hover:text-accent">{t("footer.returns")}</Link>
            </nav>
            <span>{t("footer.madeIn")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
